import { render, staticRenderFns } from "./HomeNewsDistribution.vue?vue&type=template&id=fa98003a&scoped=true"
import script from "./HomeNewsDistribution.vue?vue&type=script&lang=js"
export * from "./HomeNewsDistribution.vue?vue&type=script&lang=js"
import style0 from "./HomeNewsDistribution.vue?vue&type=style&index=0&id=fa98003a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa98003a",
  null
  
)

export default component.exports